import Vue from 'vue'
import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// import locale from 'element-ui/lib/locale/lang/en' // lang i18n
import * as echarts from 'echarts'
import '@/styles/index.scss' // global css
import moment from 'moment';
import App from './App'
import store from './store'
import router from './router'
import globalfunc from './utils/globalfunc'
import { pathDispose } from './utils/tool'

Vue.prototype.globalfunc = globalfunc
Vue.prototype.$moment= moment
Vue.prototype.$pathDispose = pathDispose

import { elFormErrorScrollIntoView } from "./utils/elFormErrorScroll.js"
Vue.directive('removeAriaHidden', {
  bind(el, binding) {
    let ariaEls = el.querySelectorAll('.el-radio__original');
    ariaEls.forEach((item) => {
      item.removeAttribute('aria-hidden');
    });
  }
});
Vue.prototype.elFormErrorScrollIntoView = elFormErrorScrollIntoView
import '@/icons' // icon
import '@/permission' // permission control

 //引入quill-editor编辑器
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor)
/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */
// if (process.env.NODE_ENV === 'production') {
//   const { mockXHR } = require('../mock')
//   mockXHR()
// }

// import remConfig from './utils/rem'

// remConfig();

// set ElementUI lang to EN
// Vue.use(ElementUI, { locale })
// 如果想要中文版 element-ui，按如下方式声明
Vue.use(ElementUI)


import elTableInfiniteScroll from 'el-table-infinite-scroll';
Vue.use(elTableInfiniteScroll);




Vue.prototype.$echarts = echarts
// Vue.use(echarts)
Vue.config.productionTip = false

new Vue({
  el: '#app',
  store,
  router,
  
  render: h => h(App)
})
